import type { Middleware } from "openapi-fetch";
import { navigateTo } from "../url/navigateTo.ts";

interface RedirectOnStatusCodeOptions {
    status: number;
    to: string | (() => string);
}

// A real page load clears the redirects under way. The integration harness calls this before each test.
const redirecting = new Set<Middleware>();

export function resetRedirectOnStatusCode() {
    redirecting.clear();
}

export function redirectOnStatusCode({ status, to }: RedirectOnStatusCodeOptions): Middleware {
    const middleware: Middleware = {
        onResponse({ response }) {
            if (response.status !== status) {
                // Return undefined to skip to the next middleware.
                return undefined;
            }

            if (redirecting.has(middleware)) {
                return new Promise(() => {});
            }

            redirecting.add(middleware);

            if (typeof to === "function") {
                navigateTo(to());
            } else {
                navigateTo(to);
            }

            // Return a promise to stop the middleware chain and prevent the execution of other middlewares.
            return new Promise(() => {});
        }
    };

    return middleware;
}
